
import React, { useEffect, useState } from 'react';
import HtmlReportWidgets from './HtmlReportWidgets/';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import {
  getBoardByIdAsync,
} from "../../redux/boardSlice";
import { Spin } from 'antd';
export default function ReportHtmlView() {
  const dispatch = useDispatch()
  const { boardId } = useParams();
  const search = useLocation().search
  const searchParams = new URLSearchParams(search)
  const boards = useSelector((state) => state.boards)

  useEffect(() => {
    dispatch(getBoardByIdAsync({ id: boardId }))
  }, [boardId])


  return (
    <div>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <h2>{boards?.selectedBoard?.name}</h2>
      </div>
      <hr />
      {boards.selectedBoard ?
        <HtmlReportWidgets
          board={boards.selectedBoard}
          selectedResource={null}
          bodyParams={JSON.parse(searchParams.get('bodyParams'))}
          drillDownParams={JSON.parse(searchParams.get('drillDownParams'))}
        />
        : <div style={{ textAlign: 'center', padding: '48px', width: '100%' }}><Spin /></div>}
    </div>

  )
}
